/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useMeditationStore } from '../store/useMeditationStore';
import PageHighlight from '@/components/PageHighlight';

export default function Highlight() {
  const { page } = useMeditationStore();

  if (!page?.page) {
    return null;
  }

  return (
    <PageHighlight
      title={page?.page?.header?.title}
      description={page?.page?.header?.description}
      thumbnail={page?.page?.header?.image}
    />
  );
}
